export const ANCHOR_CLASS = 'anchor-link';
export const CODE_LINK_CLASS = 'code-block-link';
export const CURRENT_CODE_LINK_CLASS = 'is-current';
